import type {ReactElement} from 'react';
import type {Component, Editor} from 'grapesjs';
import {Text, TextSize} from '@Components/text';
import {ADMIN_CONTROLS_LABELS, AdminControlsScope} from './email-maker-admin-controls.types';
import type {EmailMakerAdminControlsProps} from './email-maker-admin-controls.types';
import {ComponentAdminControls} from './components/component-admin-controls/component-admin-controls';
import {GlobalAdminControls} from './components/global-admin-controls/global-admin-controls';
import styles from './email-maker-admin-controls.module.scss';

/** Super-user-only admin controls for the email maker right panel. Render gated on store.isSuperUser by the caller. */
export function EmailMakerAdminControls({scope, editor, component, idEmailTemplate}: EmailMakerAdminControlsProps): ReactElement | null {
  if (scope === AdminControlsScope.COMPONENT && !component) {
    return null;
  }
  const title = scope === AdminControlsScope.COMPONENT ? ADMIN_CONTROLS_LABELS.componentHeader : ADMIN_CONTROLS_LABELS.globalHeader;
  return (
    <section className={styles.block}>
      <Text val={title} size={TextSize.MD} bold className={styles.header} />
      {renderScopeBody(scope, editor, component, idEmailTemplate)}
    </section>
  );
}

function renderScopeBody(scope: AdminControlsScope, editor: Editor, component: Component | undefined, idEmailTemplate: string | null): ReactElement | null {
  if (scope === AdminControlsScope.COMPONENT) {
    return component ? <ComponentAdminControls editor={editor} component={component} /> : null;
  }
  return <GlobalAdminControls editor={editor} idEmailTemplate={idEmailTemplate} />;
}
